/** Tab-local drafts only; never store credentials in this namespace. */
export const SESSION_DRAFT_PREFIX = "dutyon-session-draft:";
export const SESSION_DRAFT_CLEAR_EVENT = "dutyon:session-drafts-cleared";

export function clearSessionDrafts() {
  let cleared = true;
  try {
    for (const key of Object.keys(sessionStorage)) {
      if (key.startsWith(SESSION_DRAFT_PREFIX)) sessionStorage.removeItem(key);
    }
  } catch {
    cleared = false;
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(SESSION_DRAFT_CLEAR_EVENT));
  }
  return cleared;
}
